// src/utils/getRankColor.js

const getRankColor = (rank) => {
  const colors = {
    'S+': 'bg-gradient-to-r from-yellow-400 to-amber-400 text-white',
    'S': 'bg-gradient-to-r from-purple-500 to-pink-500 text-white',
    'A': 'bg-gradient-to-r from-blue-500 to-indigo-500 text-white',
    'B': 'bg-gradient-to-r from-green-500 to-emerald-500 text-white',
    'C': 'bg-gray-500 text-white',
    'C-': 'bg-gray-400 text-white',
    'D': 'bg-gray-300 text-gray-700',
    '-': 'bg-gray-200 text-gray-500'
  };
  return colors[rank] || colors['-'];
};

export default getRankColor;
